import { connect } from 'react-redux';
import { SurveyResponseState } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { ToxnotComponentProperties } from "../../core/BaseApplicationComponents/ToxnotComponent";
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicationState } from '../../../store';
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from '../../core/ToxnotReactModal';
import * as Utilities from '../../../utilities/Utilities';
import { ToxnotServiceClient } from "../../../store/ToxnotServiceClient";
import { ToxnotSignInRequiredComponent } from "../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from '../../../store/Models/UserContext';

type SurveyResponseComponentProperties =
    ToxnotComponentProperties &
    typeof SurveyResponseController.actionCreators &
    SurveyResponseState &
    RouteComponentProps<{ responseId?: string }>;

interface LocalState {
    surveyForwardResponseAlertModel: SurveyForwardResponseAlertModel
};

interface SurveyForwardResponseAlertModel {
    showForwardResponse: boolean;
    showAlert: boolean;
    isDone: boolean;
    forwardResEmail: string;
    forwardResMsg: string;
    alertClass: string;
    alertMsg: string;
};

class SurveyResponseInstructions extends ToxnotSignInRequiredComponent<SurveyResponseComponentProperties, LocalState> {
    private readonly _serviceClient: ToxnotServiceClient;

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    public constructor(props: SurveyResponseComponentProperties) {
        super(props);

        this._serviceClient = new ToxnotServiceClient();

        this._setInstructionsLanguage();

        this.state = {
            surveyForwardResponseAlertModel: {
                showForwardResponse: false,
                showAlert: false,
                isDone: false,
                forwardResEmail: "",
                forwardResMsg: "",
                alertClass: "",
                alertMsg: ""
            }
        }
    }

    public forwardResponseBtn_click = () => {
        this.setState({
            surveyForwardResponseAlertModel: {
                ...this.state.surveyForwardResponseAlertModel,
                showAlert: false,
                isDone: false,
                showForwardResponse: true,
                forwardResEmail: "",
                forwardResMsg: ""
            }
        });

        $("#forward-response-modal").modal("show");
    };

    private localizeComplianceInfoNeeded(complianceInfo: string): string {
        const lstComplianceInfo = complianceInfo.split(',');
        let array: string[] = [];
    
        for (const info of lstComplianceInfo) {
            array.push(this.localizeString(info));
        }
    
        return array.join(',').replace(new RegExp(",", "g"), ", ");  // Convert array into a comma-separated string
    }
    

    public forwardResponseSubmitButton_click = async () => {
        // helper function to show an alert
        const showAlertMessage = (type: string, message: string, showForwardRes: boolean) => {
            this.setState({
                surveyForwardResponseAlertModel: {
                    ...this.state.surveyForwardResponseAlertModel,
                    showAlert: true,
                    alertClass: "alert alert-" + type,
                    alertMsg: message,
                    showForwardResponse: showForwardRes
                }
            });
        };

        // validate email
        const emailAddress = this.state.surveyForwardResponseAlertModel.forwardResEmail.trim();

        if (!Utilities.isValidEmailAddress(emailAddress)) {
            showAlertMessage(
                "danger",
                this.localizeString("Please provide a valid email address."),
                true);

            return;
        }

        showAlertMessage(
            "info",
            this.localizeString("Forwarding survey response..."),
            false
        );

        const result = await this._serviceClient.dataCollectionResponseForward(emailAddress, this.state.surveyForwardResponseAlertModel.forwardResMsg.trim(), this.props.match.params.responseId!);

        if (!result.success) {
            showAlertMessage(
                "danger",
                this.localizeString("Sorry, there was a problem accessing the service. Please try again."),
                false
            );

            return;
        }

        this.setState({
            surveyForwardResponseAlertModel: {
                ...this.state.surveyForwardResponseAlertModel,
                isDone: true
            }
        });

        showAlertMessage(
            "success",
            this.localizeString("Survey forwarded successfully! You will receive an email when the survey has been accepted."),
            false
        );
    };

    public onChangeForwardResEmail = (value: string) => {
        this.setState({
            surveyForwardResponseAlertModel: {
                ...this.state.surveyForwardResponseAlertModel,
                forwardResEmail: value
            }
        });
    };

    public onChangeForwardResMsg = (value: string) => {
        this.setState({
            surveyForwardResponseAlertModel: {
                ...this.state.surveyForwardResponseAlertModel,
                forwardResMsg: value
            }
        });
    }

    protected renderConcreteComponent(): JSX.Element | null {
        const coreData = this.props.coreData!;
        const response = coreData.response;
        const request = coreData.request;

        let requestInstructionsToUse: string | null = null;
        
        if (request !== null) {
            requestInstructionsToUse = ((request.nativeLanguage === null) || (request.nativeLanguage === this.props.insActiveLanguage))
                ? request.requestInstructions
                : request.languageToRequestInstructionsMap[this.props.insActiveLanguage] ?? null;
        }

        return (
            <>
                <div className="tn-section-row m-0 m-b-20">
                    <div className="tn-section-col-12 p-0 infographic-section">
                        <img className="infographic-background" src="/images/SurveyInstruction_Infographic.jpg" />
                        <div className="infographic-cta-section">
                            <div className="tn-section-row m-b-10 m-r-5 m-l-5">
                                <div className="tn-section-col-12 text-right">
                                    <a href="http://help.exchange.3eco.com/suppliers/privacy-and-confidentiality" className="m-r-30" target="_blank">{this.localizeString("Privacy and Confidentiality")}</a>
                                    <a href="http://help.exchange.3eco.com/en/articles/3932070-responding-to-supplier-surveys" target="_blank" >{this.localizeString("Help")}</a>
                                </div>
                            </div>
                            <div className="tn-section-row m-r-5 m-l-5">
                                <div className="tn-section-col-12 p-0 text-right">
                                    {response.state === 0 &&
                                        <button type="button" onClick={this.forwardResponseBtn_click} className="btn btn-default forward-response-button"> {this.localizeString("Forward to New Owner")}</button>
                                    }
                                    {((request?.languageList ?? []).length > 0) &&
                                        <select id="dd-lang" name="ddLanguage" value={this.props.insActiveLanguage} className="form-control dd-list m-l-10 pull-right" onChange={(e) => this._instructionLangDropDown_Changed(e.target.value)}>
                                            {request!.languageList.map((language, index) => (
                                                <option key={index} value={language}> {this.getLocalizedDisplayNameForCultureName(language)} </option>
                                            ))}
                                        </select>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tn-section-row m-0 m-b-20">
                    {(request?.useManufacturerLogo && coreData.requestorManufacturerLogoUrl !== null && coreData.requestorManufacturerLogoUrl !== '') &&
                        <img className="ins-manufacture-logo-img" src={coreData.requestorManufacturerLogoUrl} />
                    }
                </div>
                {((request !== null) && (requestInstructionsToUse !== null) && (requestInstructionsToUse.length > 0)) &&
                    <div className="tn-section-row m-0 m-b-20">
                        <div className="tn-section-col-8 p-0">
                            <h4 className="bold-header">{this.localizeString("A Message From Your Customers")}</h4>
                            {this._renderRequestorInstructions(requestInstructionsToUse)}
                            <br />
                            <span>
                                {request.fromName}
                                {(request.fromEmailAddress.length > 0) && <>{" "}<span>({request.fromEmailAddress})</span></>}
                            </span>
                        </div>
                    </div>
                }
                {this.props.coreData?.includeAttestationLetter && this.props.coreData?.attestationLetterFileId &&
                    <div className="tn-section-row m-0 m-b-20">
                        <a href={`/Api/GeneralFile?fileId=${this.props.coreData?.attestationLetterFileId}&overrideTeamOwnerId=${this.props.coreData?.request?.ownerId}`}>See Attestation Letter</a>
                    </div>
                }
                <div className="tn-section-row m-0">
                    <div className="tn-section-col-6 p-0 p-r-10">
                        {response.isRevisionResponse &&
                            <div>
                                {this.props.coreData?.request?.sdsRequested && <p> this.localizeString("The requestor is asking for you to import an SDS file. You can import an SDS PDF file.")</p>}
                                <p>
                                    {this.localizeString("Your requestor has asked for revisions to your response:")}
                                </p>
                                <ul>
                                    {response.supplierQuestionnaireData?.revisionRequest !== null &&
                                        <li>{this.localizeString("Company-level Questionnaire")}</li>
                                    }
                                    {coreData.revisionReqInvNames?.map((resInvName, index) => (
                                        <li key={index}>
                                            {resInvName.emptyCoalesce(this.localizeString("Unnamed Material"))}
                                        </li>
                                    ))}
                                </ul>
                                <p>
                                    {this.localizeString("Walk through each step to see items marked for revision.")}
                                </p>
                            </div>
                        }
                        <div>
                            <h4 className="bold-header">{this.localizeString("How to Respond to this survey")}</h4>
                            <p>{this.localizeString("We'll walk you through step by step so you can respond to this request!")}</p>
                            <ul>
                                {coreData.needsSupplierLevelQuestionnaireResponse ?
                                    coreData.needsMaterialResponse ?
                                        <>
                                            <li>{this.localizeString("First you'll fill out a questionnaire about your company-wide data.")}</li>
                                            <li>{this.localizeString("Then you'll add material data by either typing it into a simple form, or importing from a spreadsheet or SDS file.")}</li>
                                        </>
                                        : <li>{this.localizeString("First you'll fill out a questionnaire about your company-wide data.")}</li>
                                    :
                                    <li>{this.localizeString("First you'll add material data by either typing it into a simple form, or importing from a spreadsheet or SDS file.")}</li>
                                }
                                {(request !== null) &&
                                    <>
                                        {request.dataRequested.complianceList.length > 0 &&
                                            <li> {this.localizeString("Then, you'll need to fill out information about how your materials conform to regulations, particularly:") + " " +this.localizeComplianceInfoNeeded(coreData.complianceInfoNeeded)} </li>
                                        }
                                        {request.dataRequested.sustainabilityDataAsked &&
                                            <li>{this.localizeString("You'll need to fill out sustainability information about your materials")}</li>
                                        }
                                        {request.dataRequested.circularityDataAsked &&
                                            <li>{this.localizeString("You'll also need to fill out circularity information about how your materials.")}</li>
                                        }
                                        {request.dataRequested.documentsCertificationList.length > 0 &&
                                            <li>{this.localizeString("Then, you'll need to upload some documents and certification regarding your materials.")}</li>
                                        }
                                    </>
                                }
                            </ul>
                            <p>
                                {this.localizeString("When all the data is ready, you will submit it back to your requestor.")}
                            </p>
                            {coreData.needsMaterialResponse &&
                                <p>
                                    {this.localizeString("You'll have an opportunity to save your data to use for future requests. You can even publish your data for others to search and find. If you publish your data, other customers will be able to search and find your disclosed information without even needing the send a request.")}
                                </p>
                            }
                            <p>
                                <a href="http://help.exchange.3eco.com/en/articles/3932004-overview-for-suppliers-responding-to-surveys" target="_blank">{this.localizeString("Learn more in our help center")}</a> {this.localizeString("or")} <a role="button" className="message-us-link" onClick={() => Intercom("show")}>{this.localizeString("Chat with us")}</a>
                            </p>
                        </div>
                    </div>
                    <div className="tn-section-col-6 p-0">
                        <div className="ins-how-to p-10">
                            <p className="text-center"><b>{this.localizeString("Check out our How-To Video:")}</b></p>
                            <div className="embed-container">
                                <iframe
                                    src="https://share.synthesia.io/embeds/videos/11098861-2785-48aa-9530-567965e46448?language=en"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowFullScreen
                                    title="How To: Supplier Surveys">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <ToxnotReactModal modalId={"forward-response-modal"} localizedTitle={this.localizeString("Forward Response to New Owner")}>
                    <ToxnotReactModalBody>
                        {this.state.surveyForwardResponseAlertModel.showForwardResponse &&
                            <>
                                <p>
                                    {this.localizeString("You can invite another person to take ownership of this response. When the new owner takes over, you will not longer be able to access this survey response, and the new owner will be able to view, edit, and submit all response data.")}
                                </p>
                                <div className="form-group">
                                    <label>{this.localizeString("To:")}</label>
                                    <input type="text" className="form-control" placeholder="Email Address" id="forward-response-email" value={this.state.surveyForwardResponseAlertModel.forwardResEmail} onChange={(e) => this.onChangeForwardResEmail(e.target.value)} />
                                </div>
                                <div className="form-group">
                                    <label>{this.localizeString("Message:")}</label>
                                    <textarea rows={5} className="form-control" placeholder="Optional Message" id="forward-response-message" value={this.state.surveyForwardResponseAlertModel.forwardResMsg} onChange={(e) => this.onChangeForwardResMsg(e.target.value)}></textarea>
                                </div>
                            </>
                        }
                        {this.state.surveyForwardResponseAlertModel.showAlert &&
                            <div className={this.state.surveyForwardResponseAlertModel.alertClass}>
                                {this.state.surveyForwardResponseAlertModel.alertMsg}
                            </div>
                        }
                    </ToxnotReactModalBody>
                    <ToxnotReactModalFooter localizer={this.props.appServices} enabledCloseButton={this.state.surveyForwardResponseAlertModel.showForwardResponse}>
                        {this.state.surveyForwardResponseAlertModel.isDone && <button type="button" className="btn btn-toxnot-primary" id="forward-response-done-button" data-dismiss="modal">{this.localizeString("Done")}</button>}
                        {this.state.surveyForwardResponseAlertModel.showForwardResponse && <button type="button" className="btn btn-toxnot-primary" onClick={() => this.forwardResponseSubmitButton_click()} id="forward-response-submit-button">{this.localizeString("Forward Response")}</button>}
                    </ToxnotReactModalFooter>
                </ToxnotReactModal>
            </>
        );
    }

    private _renderRequestorInstructions = (requestorInstructions: string) => {
        if (requestorInstructions != null && requestorInstructions != '') {
            return requestorInstructions.split('\n').map((line, index) => (
                <span key={index}>  {line.trim()}  <br /> </span>
            ));
        } else {
            return "";
        }
    }
    
    private _instructionLangDropDown_Changed =async (lang: string) => {
        localStorage.setItem("supplier-language", lang);
        this.setLanguage(lang);
        this.props.setSurveyResponseState({ insActiveLanguage: lang });
        await this._serviceClient.updateUserProfileLanguage(lang);
    }

    private _setInstructionsLanguage = async () => {
        const lang = localStorage.getItem("supplier-language");
        if (lang !== null) {
            this.props.setSurveyResponseState({ insActiveLanguage: lang });
        }
    }
}

export default connect((state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(withRouter(SurveyResponseInstructions) as any);
